import React from 'react';
import { motion } from 'framer-motion';
interface BuyButtonProps {
  label?: string;
  className?: string;
  onClick?: () => void;
  ariaLabel?: string;
}
/** Scrolls to the final offer / checkout section. */
export function scrollToOffer(): void {
  const el = document.getElementById('oferta');
  if (el) el.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
}
export function BuyButton({
  label = 'Get the Kit',
  className = '',
  onClick,
  ariaLabel
}: BuyButtonProps) {
  return <motion.button type="button" onClick={onClick ?? scrollToOffer} aria-label={ariaLabel ?? label} whileTap={{
    scale: 0.96
  }} className={`pulse-glow inline-flex w-full items-center justify-center gap-2 rounded-full bg-[var(--pb-lime)] px-6 py-4 font-display text-xl font-800 uppercase tracking-wide text-[var(--pb-navy)] shadow-lg shadow-lime-500/20 transition-colors hover:bg-[var(--pb-lime-dark)] ${className}`} data-id="element-36" data-mp="3gzj3bdbzosr2">
      🏓 {label}
    </motion.button>;
}